import { Check, Lock } from 'lucide-react';
import { SectionLegend } from 'components/Profile';
import Documents from './Documents';
import { signedDate } from './helper';

const Signed = ({ consentForms, patientName, onView }) => {
  const signedOn = signedDate(consentForms[0]?.attributes);
  const signedBy = ['Signed', patientName && `by ${patientName}`, signedOn && `on ${signedOn}`].filter(Boolean).join(' ');

  return (
    <>
      <div className="mb-5 flex items-start gap-4 rounded-xl border border-success-100 bg-success-50/40 p-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-success-100 bg-white text-success-600">
          <Check size={20} strokeWidth={3} />
        </span>

        <div className="min-w-0">
          <p className="text-[15px] font-bold text-secondary-900">All {consentForms.length} forms are signed</p>
          <p className="mt-1 text-xs text-secondary-500">{signedBy} · Kept on file for your records.</p>
        </div>
      </div>

      <SectionLegend>Your signed documents</SectionLegend>

      <Documents consentForms={consentForms} onView={onView} />

      <SectionLegend>Acceptance record</SectionLegend>

      <div className="flex flex-col gap-3 rounded-xl border border-gray-200 bg-secondary-50/50 p-4 sm:flex-row sm:items-center">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-success-50 text-success-600">
          <Check size={16} strokeWidth={3} />
        </span>

        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-secondary-900">
            {['Accepted electronically', patientName && `by ${patientName}`].filter(Boolean).join(' ')}
          </p>
          <p className="mt-0.5 text-xs text-secondary-400">
            {[signedOn, 'Recorded in your patient file'].filter(Boolean).join(' · ')}
          </p>
        </div>

        <span className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-success-100 bg-success-50 px-3 py-1.5 text-xs font-semibold text-success-700 sm:self-center">
          <Lock size={12} strokeWidth={2.5} /> Securely stored
        </span>
      </div>
    </>
  );
};

export default Signed;
